<div class="custom-dropdown" #customDropdownList [ngClass]="this.class">
  <div class="custom-dropdown-backdrop" (click)="closeDropdown()"></div>
  <div class="selected-box" (click)="showDropList()">
    <img
      *ngIf="this.imgageStatus && this.selectedIcon"
      [src]="'assets/svg-flags/' + this.selectedIcon + '.svg'"
      width="20"
      height="20"
    />
    <input
      type="text"
      readonly
      [value]="this.selectedValue"
      [placeholder]="defaultplaceholder"
      class="custom-select"
    />
  </div>
  <div class="list-item-box">
    <div
      *ngIf="this.downDownHeaderStatus"
      class="ng-row border-bottom border-color-aee"
      justify-content-between
      align-item-center
    >
      <div class="ng-col pd" col-auto>
        <div class="color-3ae font-14">Select one</div>
      </div>
      <div class="ng-col pd" col-auto>
        <i class="icon-close-black link" (click)="closeDropdown()"></i>
      </div>
    </div>
    <input
      *ngIf="this.searchStatus"
      type="text"
      placeholder="Search"
      [(ngModel)]="this.filterTerm"
      class="p-l-r font-14 border-color-aee"
    />
    <div class="list-item-box-scroll custom-scrollbar">
      <div
        class="list-item"
        *ngFor="let a of this.dropDownData | searchPipe: filterTerm"
        (click)="selectDropVal(a)"
      >
        <img
          *ngIf="this.imgageStatus"
          [src]="'assets/svg-flags/' + a.iconClass + '.svg'"
          width="20"
          height="20"
        />
        <div class="num">{{ countryCodePlus }} {{ a.displayValue }}</div>
      </div>
    </div>
  </div>
</div>
